import { Injectable } from "@angular/core";
import { Doenca } from "@tivic-team/manager-ts/dist/grl";
import { CartaoDocumentoDoenca } from "@tivic-team/manager-ts/dist/mob/entities/cartao-documento-doenca.entity";
import { Cartao } from "@tivic-team/manager-ts/dist/mob/entities/cartao.entity";
import { CartaoDocumentoDTO, CartaoDocumentoListDTO } from "app/model/dtos/mob/cartao-documento.dto";
import { PessoaFichaMedicaDTO } from "app/model/dtos/mob/pessoa-ficha-medica.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";


@Injectable()
export class GratuidadeSolicitacoesController{
    constructor() {}

    async create(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/cartoesdocumentos',
                    environment: environment
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );
        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<CartaoDocumentoListDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos',
                    environment: environment,
                    filter: filtros
                }),
            }),

            new HttpResponse(
                new Array<Cartao>()
            )
        );

        return await quark.call();
    }


    async get(cdCartaoDocumento: Number): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async getDeficiencia(cdCartaoDocumento: Number): Promise<Array<Doenca>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/deficiencia',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new Array<Doenca>()
            )
        );

        return quark.call();
    }

    async getCartaoDocumentoDoenca(cdCartaoDocumento: Number): Promise<Array<CartaoDocumentoDoenca>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/cids',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new Array<CartaoDocumentoDoenca>()
            )
        );

        return quark.call();
    }

    async getTramitacao(cdDocumento: Number): Promise<Array<CartaoDocumentoListDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdDocumento/tramitacoes',
                    environment: environment,
                    pathParams: new JSONData({cdDocumento: cdDocumento})
                }),
            }),
            new HttpResponse(
                new Array<CartaoDocumentoListDTO>()
            )
        );

        return quark.call();
    }

    async getPessoaFichaMedicaByCPF(nrCpf: String): Promise<PessoaFichaMedicaDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/pessoa/:nrCpf',
                    environment: environment,
                    pathParams: new JSONData({nrCpf: nrCpf})
                }),
            }),
            new HttpResponse(
                new PessoaFichaMedicaDTO()
            )
        );

        return quark.call();
    }

    async getOcorrencias(cdCartaoDocumento: Number): Promise<Array<CartaoDocumentoListDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/ocorrencias',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new Array<CartaoDocumentoListDTO>()
            )
        );

        return quark.call();
    }

    async getCartao(cdCartaoDocumento: Number): Promise<Cartao>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/cartao',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new Cartao()
            )
        );

        return quark.call();
    }

    async getPessoasByCartaoDocumento(cdCartaoDocumento: Number): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/enderecos',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cdCartaoDocumento})
                }),
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async update(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento})
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO(), 
                1000 * 1000
            )
        );

        return quark.call();
    }

    async updateOcorrenciasDeferimento(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/deferimento',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento})
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async updateOcorrenciasIndeferimento(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/indeferimento',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento})
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async updateOcorrenciasAnulacao(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/anulacao',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento})
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async updateMarcarPericia(cartaoDocumentoDTO: CartaoDocumentoDTO): Promise<CartaoDocumentoDTO>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/cartoesdocumentos/:cdCartaoDocumento/marcarpericia',
                    environment: environment,
                    pathParams: new JSONData({cdCartaoDocumento: cartaoDocumentoDTO.cartaoDocumento.cdCartaoDocumento})
                }),
                data: new JSONData(cartaoDocumentoDTO)
            }),
            new HttpResponse(
                new CartaoDocumentoDTO()
            )
        );

        return quark.call();
    }

    async getSolicitacaoProcedimentoReport(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/relatorio/solicitacaoprocedimento',
                    environment: environment,
                    filter: filtros
                }),
                responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }

    async getSolicitacaoCartaoReport(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/relatorio/solicitacaocartao',
                    environment: environment,
                    filter: filtros
                }),
                responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }

    async getEmissaoCIReport(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/relatorio/emissaoci',
                    environment: environment,
                    filter: filtros
                }),
                responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }
}